import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { UserService } from '@core/services/user.service';
import { UserPreferencesService } from '@core/use-case-services/user-preferences.service';
import { AlertController, NavController } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';
import { map, of, switchMap, tap } from 'rxjs';

@Component({
  selector: 'gt-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  translocoService = inject(TranslocoService);
  navController = inject(NavController);
  alertController = inject(AlertController);
  userService = inject(UserService);
  authService = inject(AuthService);
  userPreferencesService = inject(UserPreferencesService);

  public isLogged = false;
  public showLanguageSelector = false;

  public user$ = this.userService.user$;
  public languages$ = this.translocoService.langChanges$.pipe(
    map((lang) => [
      {
        label: 'Español',
        type: 'radio',
        value: 'es',
        checked: lang === 'es',
        handler: () => {
          this.updateLang('es');
          this.alertController.dismiss();
        },
      },
      {
        label: 'English',
        type: 'radio',
        value: 'en',
        checked: lang === 'en',
        handler: () => {
          this.updateLang('en');
          this.alertController.dismiss();
        },
      },
      {
        label: 'Français',
        type: 'radio',
        value: 'fr',
        checked: lang === 'fr',
        handler: () => {
          this.updateLang('fr');
          this.alertController.dismiss();
        },
      },
      {
        label: 'Italiano',
        type: 'radio',
        value: 'it',
        checked: lang === 'it',
        handler: () => {
          this.updateLang('it');
          this.alertController.dismiss();
        },
      },
      {
        label: 'Português',
        type: 'radio',
        value: 'pt',
        checked: lang === 'pt',
        handler: () => {
          this.updateLang('pt');
          this.alertController.dismiss();
        },
      },
    ]),
  );

  private updateLang(lang: string) {
    this.translocoService.setActiveLang(lang);
    localStorage.setItem('lang', lang);
    if (this.isLogged) {
      this.userPreferencesService.createOrUpdatePreferences({
        language: lang,
      });
    }
  }

  ngOnInit(): void {
    this.authService.isLoggedIn$
      .pipe(
        switchMap((isLogged) => {
          this.isLogged = isLogged;
          if (isLogged) {
            return this.userPreferencesService.myLanguage$;
          }
          return of(localStorage.getItem('lang') ?? 'en');
        }),
        tap((lang) => {
          // Sincronizar idioma: Firestore es la fuente de verdad para usuarios logueados
          const currentLang = this.translocoService.getActiveLang();
          const localLang = localStorage.getItem('lang');

          if (this.isLogged && lang) {
            // Si Firestore tiene un valor diferente al localStorage, actualizamos localStorage
            if (localLang !== lang) {
              localStorage.setItem('lang', lang);
            }
            // Aplicar el idioma de Firestore si es diferente al actual
            if (currentLang !== lang) {
              this.translocoService.setActiveLang(lang);
            }
            return;
          }

          // Caso no logueado: aplicar el idioma entrante si es distinto del actual
          if (lang && lang !== currentLang) {
            this.translocoService.setActiveLang(lang);
          }
        }),
      )
      .subscribe();
  }
}
